// 专项流程
import { request } from "../network/request";
const db = "dn0";
/**
 * 项目续约统计列表
 * @param {*} params 
 * @returns 
 */
export function getXytjList(params) {
    return request({
        url: "pmp/zxlc/xytjList",
        method: "post",
        params,
    });
}
/**
 * 项目续约统计列表 导出
 * @param {*} params 
 * @returns 
 */
export function exportXytjList(params) {
    return request({
        url: "pmp/zxlc/xytjListExport",
        method: "post",
        params,
    });
}

/**
 * 报表钻取明细
 * @param {*} params 
 * @returns 
 */
export function getBbmxList(params) {
    return request({
        url: "pmp/zxlc/xmmxList",
        method: "post",
        params,
    });
}
/**
 * 导出报表钻取明细
 * @param {*} params 
 * @returns 
 */
export function exportBbmxList(params) {
    return request({
        url: "pmp/zxlc/xmmxListExport",
        method: "post",
        params,
    });
}
/**
 * 项目续约明细列表
 * @param {*} params 
 * @returns 
 */
export function getXymxList(params) {
    return request({
        url: "pmp/zxlc/xymxList",
        method: "get",
        params,
    });
}
/**
 * 项目续约明细列表明细导出
 * @param {*} params 
 * @returns 
 */
export function exportXymxList(params) {
    return request({
        url: "pmp/zxlc/xymxExport",
        method: "get",
        params,
    });
}


/**
 * 项目续约发函明细
 * @param {*} params 
 * @returns 
 */

export function getXyfhList(params) {
    return request({
        url: "pmp/zxlc/xyfhList",
        method: "get",
        params,
    });
}
/**
 * 项目续约发函明细导出
 * @param {*} params 
 * @returns 
 */
export function exportXyfhList(params) {
    return request({
        url: "pmp/zxlc/xyfhExport",
        method: "get",
        params,
    });
}

/**
 * 项目续约发函-无需发函确认
 * @param {*} params 
 * @returns 
 */
export function updateXmxyfh(params) {
    return request({
        url: "pmp/zxlc/updateXmxyfh",
        method: "post",
        params,
    });
}

/**
 * 项目续约查看
 * @param {*} params 
 * @returns 
 */
export function selectXy(params) {
    return request({
        url: "pmp/zxlc/selectXy",
        method: "post",
        params,
    });
}

/**
 * 
确认发函完成
 * @param {*} params 
 * @returns 
 */
export function xyConfirm(params) {
    return request({
        url: "pmp/zxlc/xyConfirm",
        method: "post",
        params,
    });
}

/**
 * 获取续约结果登记
 * @param {*} params 
 * @returns 
 */
export function getXmxydj(params) {
    return request({
        url: "pmp/zxlc/getXmxydj",
        method: "get",
        params,
    });
}

/**
 * 续约结果登记
 * @param {*} params 
 * @returns 
 */
export function saveXmxydj(params) {
    return request({
        url: "pmp/zxlc/saveXmxydj",
        method: "get",
        params,
    });
}

/**
 * 1-函件附件 2-邮件回执 3-电子邮件上传
 * @param {*} params 
 * @returns 
 */
export function uploadFile(params) {
    return request({
        url: "pmp/zxlc/uploadFile",
        method: "post",
        data: params,
    });
}
/**
 * 发函申请保存
 * @param {*} params 
 * @returns 
 */
export function insertFhsq(params) {
    return request({
        url: "pmp/zxlc/insertFhsq",
        method: "post",
        data: params,
    });
}

/**
 * 项目一把手变更明细列表
 * @param {*} params 
 * @returns 
 */
export function getYbsbgList(params) {
    return request({
        url: "pmp/zxlc/ybsbgList",
        method: "get",
        params,
    });
}
/**
 * 项目一把手变更明细列表导出
 * @param {*} params 
 * @returns 
 */
export function exportYbsbgList(params) {
    return request({
        url: "pmp/zxlc/ybsbgExport",
        method: "get",
        params,
    });
}

/**
 * 一把手变更发函明细列表
 * @param {*} params 
 * @returns 
 */
export function getYbsbgfhList(params) {
    return request({
        url: "pmp/zxlc/ybsbgfhList",
        method: "get",
        params,
    });
}
/**
 * 一把手变更发函明细列表导出
 */
export function ybsbgfhExport(params) {
    return request({
        url: "pmp/zxlc/ybsbgfhExport",
        method: "get",
        params,
    });
}

/**
 * 行领导明细列表
 * @param {*} params 
 * @returns 
 */
export function getHldmxList(params) {
    return request({
        url: "pmp/zxlc/hldmxList",
        method: "get",
        params,
    });
}

/**
 * 行领导明细导出
 * @param {*} params 
 * @returns 
 */
export function exportHldmxList(params) {
    return request({
        url: "pmp/zxlc/hldmxExport",
        method: "get",
        params,
    });
}
/**
 * 一把手变更统计
 * @param {*} params 
 * @returns 
 */
export function getYbsbgTjList(params) {
    return request({
        url: "pmp/zxlc/ybsbgTjList",
        method: "get",
        params,
    });
}
export function ybsbgTjExport(params) {
    return request({
        url: "pmp/zxlc/ybsbgTjExport",
        method: "get",
        params,
    });
}

/**
 * 项目一把手变更未到岗明细
 * @param {*} params 
 * @returns 
 */
export function getWdgList(params) {
    return request({
        url: "pmp/zxlc/ybsbgwdgList",
        method: "get",
        params,
    });
}
export function ybsbgwdgExport(params) {
    return request({
        url: "pmp/zxlc/ybsbgwdgExport",
        method: "get",
        params,
    });
}


// 首页
export function selectZxlc(params) {
    return request({
        url: "pmp/zxlc/selectZxlc",
        method: "post",
        params,
    });
}

/**
 * 一把手变更申请保存
 * @param {*} params 
 * @returns 
 */
export function saveYbsbgsq(params) {
    return request({
        url: "pmp/zxlc/saveYbsbgsq",
        method: "post",
        data: params,
    });
}

/**
 * 一把手变更查看
 * @param {*} params 
 * @returns 
 */
export function selectybsbg(params) {
    return request({
        url: "pmp/zxlc/selectybsbg",
        method: "post",
        params,
    });
}

/**
 * 一把手变更发函处理完成
 * @param {*} params 
 * @returns 
 */
export function ybsbgxyConfirm(params) {
    return request({
        url: "pmp/zxlc/ybsbgxyConfirm",
        method: "post",
        params,
    });
}


/**
 * 获取一把手变更申请表单数据
 * @param {*} params 
 * @returns 
 */
export function getYbsbgsqById(params) {
    return request({
        url: "pmp/zxlc/getYbsbgsqById",
        method: "get",
        params,
    });
}

/**
 * 一把手变更申请表单保存后创建进度
 * @param {*} params 
 * @returns 
 */
export function insertProgram(params) {
    return request({
        url: "pmp/zxlc/insertProgram",
        method: "post",
        params,
    });
}
/**
 * 项目续约明细结果修改登记
 * @param {*} params 
 * @returns 
 */
export function xmxybg(params) {
    return request({
        url: "pmp/zxlc/xmxybg",
        method: "get",
        params,
    });
}

// /**
//  * 项目续约首页数据
//  * @param {*} params
//  * @returns
//  */
// export function selectZxlc(params) {
//     return request({
//         url: "pmp/zxlc/selectZxlc",
//         method: "get",
//         params,
//     });
// }
/**
 * 续约明细成果物列表
 * @param {*} params 
 * @returns 
 */
export function getTaskFileList(params) {
    return request({
        url: "pmp/zxlc/getTaskFileList",
        method: "get",
        params,
    });
}

